export const defaultAssistantConfigData: any = {
  id: '',
  region: '',
  workingHoursStart: '',
  workingHoursEnd: '',
  workingDays: [],
  timezone: '',
  isActive: false,
  isRemoved: false
}
